import React from 'react';
import { TrendingUp, Clock, Users, DollarSign } from 'lucide-react';
import { SlideLayout } from './SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ImpactSlide(props: SlideProps) {
  return <SlideLayout {...props} title="The Impact" subtitle="Transforming operational efficiency for educational institutions." data-id="element-66">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12" data-id="element-67">
        <div className="bg-indigo-50 p-8 rounded-3xl border border-indigo-100 flex flex-col items-center text-center" data-id="element-68">
          <div className="text-5xl font-bold text-indigo-600 mb-2" data-id="element-69">99%</div>
          <div className="text-sm font-bold text-indigo-900 uppercase tracking-wider mb-4" data-id="element-70">
            Time Saved
          </div>
          <p className="text-indigo-700 text-sm" data-id="element-71">
            Reduction in assessment creation time from weeks to seconds.
          </p>
        </div>

        <div className="bg-emerald-50 p-8 rounded-3xl border border-emerald-100 flex flex-col items-center text-center" data-id="element-72">
          <div className="text-5xl font-bold text-emerald-600 mb-2" data-id="element-73">10x</div>
          <div className="text-sm font-bold text-emerald-900 uppercase tracking-wider mb-4" data-id="element-74">
            Output Volume
          </div>
          <p className="text-emerald-700 text-sm" data-id="element-75">
            Faculty can generate more practice sets and variations effortlessly.
          </p>
        </div>

        <div className="bg-amber-50 p-8 rounded-3xl border border-amber-100 flex flex-col items-center text-center" data-id="element-76">
          <div className="text-5xl font-bold text-amber-600 mb-2" data-id="element-77">$0</div>
          <div className="text-sm font-bold text-amber-900 uppercase tracking-wider mb-4" data-id="element-78">
            Outsourcing Cost
          </div>
          <p className="text-amber-700 text-sm" data-id="element-79">
            Eliminate the need for external content creators or typists.
          </p>
        </div>

        <div className="bg-slate-50 p-8 rounded-3xl border border-slate-200 flex flex-col items-center text-center" data-id="element-80">
          <div className="text-5xl font-bold text-slate-600 mb-2" data-id="element-81">100%</div>
          <div className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-4" data-id="element-82">
            Brand Consistency
          </div>
          <p className="text-slate-600 text-sm" data-id="element-83">
            Every exported PDF perfectly matches institutional guidelines.
          </p>
        </div>
      </div>

      <div className="mt-12 bg-slate-900 rounded-2xl p-8 text-white flex items-center justify-between" data-id="element-84">
        <div data-id="element-85">
          <h4 className="text-xl font-bold mb-1" data-id="element-86">Early Pilot Results</h4>
          <p className="text-slate-400" data-id="element-87">Data from 5 partner universities</p>
        </div>
        <div className="flex gap-8 text-right" data-id="element-88">
          <div data-id="element-89">
            <div className="text-3xl font-bold text-emerald-400" data-id="element-90">5,000+</div>
            <div className="text-xs text-slate-400 uppercase" data-id="element-91">
              Papers Generated
            </div>
          </div>
          <div data-id="element-92">
            <div className="text-3xl font-bold text-emerald-400" data-id="element-93">20,000</div>
            <div className="text-xs text-slate-400 uppercase" data-id="element-94">Hours Saved</div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}